import { database } from '../firebase';

const subscribeToInfo = (onReceive, onDelete) => {
  const ref = database.ref(`infos`);

  const handler = (snapshot) => onReceive(snapshot.key, snapshot.val());

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on('child_added', handler);
  ref.on('child_changed', handler);
  ref.on('child_removed', handlerOnDelete);

  return () => {
    ref.off('child_added', handler);
    ref.off('child_changed', handler);
    ref.off('child_removed', handlerOnDelete);
  };
};

const getVideoHelpURL = (onReceive) =>
  new Promise((resolve, reject) => {
    database
      .ref(`infos/videoHelpURL`)
      .once('value')
      .then((snapshot) =>
        snapshot.exists()
          ? resolve(snapshot.val())
          : reject('No existe ningún video de ayuda.')
      )
      .catch(() => reject('Ocurrió un error.'));
  });

export default {
  subscribeToInfo,
  getVideoHelpURL,
};
